import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import NotificationBar from '../../components/NotificationBar';

const mapStateToProps = (state: StoreState) => {
	const { notificationBar } = state;
	return { notificationBar };
};

export default connect(mapStateToProps)(NotificationBar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotificationBar/index.tsx